import { render, staticRenderFns } from "./table-robstrader.component.vue?vue&type=template&id=8ec6fcae"
import script from "./table-robstrader.component.vue?vue&type=script&lang=js"
export * from "./table-robstrader.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports